import {h} from "preact";
import {BLOCKS, MARKS} from "@contentful/rich-text-types";
import styled from "styled-components";
import SyntaxHighlighter from 'react-syntax-highlighter';
import { defaultStyle } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import {gridSize, lightGrey} from "../style-variables";
import {Options} from "@contentful/rich-text-react-renderer";

const BlockQuote = styled.blockquote`
    border-left: 1px solid ${lightGrey};
    padding-left: ${gridSize * 2}px;
    color: ${lightGrey};
`

const InlineCode = styled.code`
    background: #F4F5F7;
    padding: 0 6px;
    border-radius: 3px;
    white-space: nowrap;
`

export const renderNode = {
    [BLOCKS.QUOTE]: (node, children) => (<BlockQuote>{children}</BlockQuote>),
    [BLOCKS.PARAGRAPH]: (node, children) => {
        if (node.content.length === 1 && node.content[0].marks[0]?.type === MARKS.CODE) {
            console.log(node.content[0].value);
            return <SyntaxHighlighter style={defaultStyle} showLineNumbers={true}>{node.content[0].value}</SyntaxHighlighter>
        }
        return <div>{children}</div>
    }
}

export const renderMark = {
    [MARKS.CODE]: text => <InlineCode>{text} </InlineCode>
}

export const contentfulRenderOptions: Options = {
    renderNode,
    renderMark
}
